<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="3">
              <h1>
                <feather-icon icon="AwardIcon" size="30" class="mr-50" />
                Pontos Manuais
              </h1>
            </b-col>
            <b-col lg="6">
              <b-form @submit.prevent="fetchPontos">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filtro.search"
                    placeholder="Buscar pontos manuais"
                  />
                </b-input-group>
              </b-form>
            </b-col>
            <b-col lg="3">
              <b-button variant="primary button-right" :to="'/PontosManuais/cadastrar'">
                Adicionar Pontos</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body class="mb-0">
      <b-table
        ref="refPontosListTable"
        style="min-height: 50vw"
        class="position-relative"
        :items="fetchedPontos?.content"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Não há pontos manuais cadastrados"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(dataCriacao)="data">
          {{ formatDate(data.item.dataCriacao) }}
        </template>

        <template #cell(dataInsercao)="data">
          {{ formatDate(data.item.dataInsercao) }}
        </template>

        <template #cell(motivo)="data">
          <b-badge variant="info">
            {{ data.item.motivo }}
          </b-badge>
        </template>

        <template #cell(pontuacao)="data">
          <b-badge variant="primary">
            {{ data.item.pontuacao !== null && data.item.pontuacao !== undefined ? data.item.pontuacao.toFixed(1) : '-' }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            
            <b-dropdown-item
              :to="{ name: 'PontosManuaisEditar', params: { id: data.item.id} }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>

            <b-dropdown-item
              @click="deletePonto(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BForm,
  BBadge,
} from 'bootstrap-vue'
import { hideSpinner, showSpinner } from '@/services/spinService'
import pontosManuaisService from '@/services/pontosManuaisService'
import utilsService from '@/services/utilsService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BRow,
    BCol,
    BButton,
    BForm,
    BBadge,
    ToastificationContent,
  },
  data: () => ({
    filtro: { 
      search: '',
      page: 1,
      itemsPerPage: 10
    },
    perPage: 10,
    totalPontos: 0,
    currentPage: 1,
    perPageOptions: [10, 25, 50, 100],
    searchQuery: '',
    sortBy: 'id',
    isSortDirDesc: true,
    fetchedPontos: [],
    tableColumns: [
    { key: 'nomeAluno', label: 'Aluno', sortable: false },
      { key: 'nomeEscola', label: 'Escola', sortable: false },
      { key: 'nomeTurma', label: 'Turma', sortable: false },
      { key: 'motivo', label: 'Desafio', sortable: false },
      { key: 'pontuacao', label: 'Pontuação', sortable: false },
      { key: 'dataInsercao', label: 'Data', sortable: false },
      { key: 'actions', label: 'Ações', sortable: false },
    ],
  }),
  mounted() {
    this.fetchPontos()
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      try {
        const dateObj = new Date(date)
        return dateObj.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return '-'
      }
    },
    
    async fetchPontos() {
      showSpinner()
      
      // Limpa o filtro removendo valores vazios
      const cleanFilter = utilsService.cleanObject(this.filtro)
      
      this.fetchedPontos = await pontosManuaisService.getAll(cleanFilter)
      hideSpinner()
    },

    async deletePonto(ponto) {
      try {
        await this.$bvModal.msgBoxConfirm(
          'Tem certeza que deseja excluir este ponto manual?',
          {
            title: 'Confirmar Exclusão',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Sim',
            cancelTitle: 'Não',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )

        showSpinner()
        await pontosManuaisService.delete(ponto.id)
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ponto manual excluído com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        this.fetchPontos()
        hideSpinner()
      } catch (error) {
        hideSpinner()
        if (error !== 'cancel') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao excluir ponto manual',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

